import { useQuery } from "@apollo/client";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { TerminalClosure } from "@towersystems/roam-common/lib/generated-types";
import { ModalCloseButton, createStackHeaderNavigator } from "@towersystems/roam-common-native";
import {
  CloseShiftRootScreenParamList,
  ShiftRootParamList,
} from "../../../../types";
import { QUERY_TERMINAL_SHIFT } from "../../../../utilities/terminal-shift/constants";
import { CloseShiftController } from "../../components/CloseShiftController/CloseShiftController";
import { useEndOfShiftContextProvider } from "../../utils/shift/hooks";
import { CloseCountCashScreen } from "../CloseCountCashScreen";
import { CloseShiftNoteScreen } from "../CloseShiftNoteScreen";

const ShiftDrawer = createStackHeaderNavigator<CloseShiftRootScreenParamList>();

export interface CloseShiftScreenProps
  extends StackScreenProps<ShiftRootParamList, "CloseShiftRootScreen"> {}

export const CloseShiftRootScreen = ({}: CloseShiftScreenProps) => {
  const { shiftTerminal } = useEndOfShiftContextProvider();

  const { loading, data, error } = useQuery<{
    terminalClosure: TerminalClosure;
  }>(QUERY_TERMINAL_SHIFT, {
    variables: { id: shiftTerminal.openTerminalClosureId },
  });

  const item = data?.terminalClosure;

  if (loading || error || !item) {
    return null;
  }

  return (
    <CloseShiftController terminal={shiftTerminal} terminalClosure={item}>
      <ShiftDrawer.Navigator
        screenOptions={{
          title: "Close Shift Process",
        }}
      >
        <ShiftDrawer.Group
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        >
          <ShiftDrawer.Screen
            name="CloseCountCashScreen"
            component={CloseCountCashScreen}
          />
          <ShiftDrawer.Screen
            name="CloseShiftNoteScreen"
            component={CloseShiftNoteScreen}
          />
        </ShiftDrawer.Group>
      </ShiftDrawer.Navigator>
    </CloseShiftController>
  );
};
